import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { getGoogleRedirectUri } from "../utils/googleAuth";
import { consumeRememberedNext } from "../utils/authRedirect";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      try {
        const referral_code = localStorage.getItem("sf_ref") || null;

        // Flow OAuth standard Google : ?code=... (Google Cloud Console)
        const search = new URLSearchParams(window.location.search);
        const code = search.get("code");
        if (code) {
          const { data } = await api.post("/auth/google", {
            code,
            redirect_uri: getGoogleRedirectUri(),
            referral_code,
          });
          if (data?.access_token) {
            localStorage.setItem("sf_token", data.access_token);
          }
          if (data?.user) setUser(data.user);
          window.history.replaceState({}, document.title, window.location.pathname);
          // Reprend l'achat commence avant la connexion Google, s'il y en avait un.
          const pending = consumeRememberedNext();
          navigate(pending || "/dashboard", { state: { user: data?.user } });
          return;
        }

        // Aucun code reconnu
        navigate("/login");
      } catch (e) {
        console.error("Auth callback error", e);
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-spin h-10 w-10 border-4 border-brand-green border-t-transparent rounded-full mx-auto" />
        <p className="mt-4 text-gray-600">Connexion en cours...</p>
      </div>
    </div>
  );
}
